import cn from 'classnames';
import styles from './ProductDetailed.module.scss';
import { ProductDetailedType } from '@/types';
import { ProductGallery, ProductInfo } from '@/modules/Product';
import { ReviewsAndQuestions } from '@/modules/Product/ReviewsAndQuestions';

type ProductDetailedProps = {
  product: ProductDetailedType;
  className?: string;
};

export function ProductDetailed({ className, product }: ProductDetailedProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <div className={styles.gallery}>
        <ProductGallery className={styles.gallerySlider} product={product} />
      </div>
      <div className={styles.info}>
        <ProductInfo product={product} />
        <ReviewsAndQuestions product={product} />
      </div>
    </div>
  );
}
